import { observable } from "mobx";
import AgendamentoContainerService from "../../../../../services/AgendamentoContainerService";

export default class CardBookingContainersStore {

    tipoAgenda;

    @observable ISOs;
    @observable tiposMercadoria;
    @observable tiposMercadoriaBloqueado;
    @observable transitoAduaneiroCheck
    @observable ISOsBloqueado;
    @observable atualizaSobremedida;
    

    constructor(tipoAgenda) {
        this.tipoAgenda = tipoAgenda;
        this.atualizaSobremedida = true;

        this.transitoAduaneiroCheck = false
        this.service = new AgendamentoContainerService();
    };

    carregarISOs = (tipoContainer, NumBooking) => {
        this.ISOs = false;
        this.ISOsBloqueado = true;
        if (!tipoContainer) return;
        if (tipoContainer)
            this.service.listarISOs(tipoContainer, NumBooking).then(response => {
                this.ISOs = response.data;
                this.ISOsBloqueado = false;
            }).catch( erro => {
                console.log(erro)
            });
    };

    buscarTiposMercadoria = (tipoAgenda, isRefrigerada) => {
        this.service.buscarTiposMercadoria(tipoAgenda, isRefrigerada).then(response => {
            if (response.data) {
                this.tiposMercadoria = response.data;
                this.tiposMercadoriaBloqueado = false;
            }
        }).catch(erro => {
            console.log(erro)
        });
    };


    validarISOCarregarMercadorias = (cdiso, container, setdados) => {
        this.containerModificando = container;
        this.tiposMercadoria = [];
        this.tiposMercadoriaBloqueado = true;
        // Não desejo fazer uma requisição com o valor de cdiso vazio
        if(cdiso!=null && cdiso.length > 0){
            //setdados(`${this.containerModificando}.valid.ISO_lblNaoExiste`, "Buscando ISO");
            this.service.validarISO(cdiso).then(response => {
                if (response.data) {
                    this.buscarTiposMercadoria(this.tipoAgenda.value, response.data.Refrigerado==="V")
                    setdados(`${this.containerModificando}.valid.ISO_lblNaoExiste`, "");
                } else {
                    setdados(`${this.containerModificando}.valid.ISO_lblNaoExiste`, "ISO não encontrado");
                }
            }).catch(erro => {
                console.log(erro)
                //setdados(`${this.containerModificando}.valid.ISO_lblNaoExiste`, "");
            });
        }else{
            setdados(`${this.containerModificando}.valid.ISO_lblNaoExiste`, "");
            this.tiposMercadoria = [];
            //eu mando limpar o lblNaoExiste pois o usuario pode limpar o resultado depois
        }
    };

    setTransitoAduaneiro = (value) => {
        if(value === "S") this.transitoAduaneiroCheck = true
        else this.transitoAduaneiroCheck = false
    }

    ISOLiberaSobremedida = async (iso) => {

        let response = await this.service.ISOLiberaSobremedida(iso.toUpperCase());
        return response.data.IsSuccessfull ? response.data.Data : false;

    };

};




// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-cadastrar/entrada-containers/stores/CardBookingContainersStore.js